import { IAlbum } from "../../common/Album";

const album: IAlbum = {
  title: 'Rainbows and Unicorns',
  date: new Date(2023, 7, 13),
  img: '/img/plum.jpeg',
  tracks: [
    {
      title: 'Part of a Tune',
      src: '/songs/2023-08-13/part_of_a_tune.mp3',
    },
    {
      title: 'Through The Looking Glass',
      src: '/songs/2023-08-13/through_the_looking_glass.mp3',
    },
    {
      title: 'What does this Button do?',
      src: '/songs/2023-08-13/what_does_this_button_do.mp3',
    },
    {
      title: 'Whiskey Dixie',
      src: '/songs/2023-08-13/whiskey_dixie.mp3',
    },
    {
      title: 'Rampant Overconsumerism',
      src: '/songs/2023-08-13/rampant_overconsumerism.mp3',
    },
    {
      title: 'A Dream Come True',
      src: '/songs/2023-08-13/a_dream_come_true.mp3',
    },
    {
      title: 'Two Soloists and a Mic',
      src: '/songs/2023-08-13/two_soloists_and_a_mic.mp3',
    },
    {
      title: 'Choking on One\' Own Sweat',
      src: '/songs/2023-08-13/choking_on_ones_own_sweat.mp3',
    },
    {
      title: 'Plums & Prunes / Everybody\'s got their own Problems / The Bathroom\'s Out of Order',
      src: '/songs/2023-08-13/plums_and_prunes.mp3',
    },
    {
      title: 'All is Forgiven',
      src: '/songs/2023-08-13/all_is_forgiven.mp3',
    },
    {
      title: 'Adventurous Critters of the Night',
      src: '/songs/2023-08-13/adventurous_critters_of_the_night.mp3',
    },
    {
      title: 'Upper Decker',
      src: '/songs/2023-08-13/upper_decker.mp3',
    },
  ]
}
export default album;